import React from 'react';

interface UXEnhancerProps {
  children: React.ReactNode;
}

export const UXEnhancer: React.FC<UXEnhancerProps> = ({ children }) => {
  return <>{children}</>;
};

interface PageTransitionProps {
  children: React.ReactNode;
  className?: string;
}

export const PageTransition: React.FC<PageTransitionProps> = ({ children, className = '' }) => {
  return (
    <div className={`transition-all duration-300 ease-in-out ${className}`}>
      {children}
    </div>
  );
};

interface EmptyStateProps {
  title?: string;
  description?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ 
  title = '暂无内容', 
  description = '这里还没有任何内容',
  icon,
  action 
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      {icon && <div className="mb-4 text-gray-400">{icon}</div>}
      <h3 className="text-lg font-medium text-gray-900 mb-2">{title}</h3>
      <p className="text-gray-500 mb-4">{description}</p>
      {action && action}
    </div>
  );
};